import { render, staticRenderFns } from "./addComment.vue?vue&type=template&id=2d163b0e&scoped=true"
import script from "./addComment.vue?vue&type=script&lang=js"
export * from "./addComment.vue?vue&type=script&lang=js"
import style0 from "./addComment.vue?vue&type=style&index=0&id=2d163b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d163b0e",
  null
  
)

export default component.exports